import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpToken'

// ── Rounds ─────────────────────────────────────────────────────────────────
export const roundsList = (params = '') => Http.get(`/admin/token-sale/rounds${serialize(params)}`)
export const roundById = id => Http.get(`/admin/token-sale/rounds/${id}`)
export const createRound = params => Http.post('/admin/token-sale/rounds', params)
export const updateRound = params => Http.put(`/admin/token-sale/rounds/${params.id}`, params)
export const deleteRound = id => Http.delete(`/admin/token-sale/rounds/${id}`)
export const roundOnchain = id => Http.get(`/admin/token-sale/rounds/${id}/onchain`)

// ── Whitelist entries ────────────────────────────────────────────────────────
export const entriesList = (params = '') => Http.get(`/admin/token-sale/entries${serialize(params)}`)
export const updateEntryStatus = (entryId, status) =>
	Http.patch(`/admin/token-sale/entries/${entryId}/status`, { status })

// CSV export of captured ETH addresses (downloaded as a blob to carry the bearer header).
export const exportEntries = roundId =>
	Http.get(`/admin/token-sale/rounds/${roundId}/export`, { responseType: 'blob' })
